
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ReactDOM from 'react-dom';
import Cropper from 'react-cropper';
import BVLoader20 from 'Components/loaders/BVLoader/BVLoader20';
import EmptyState from 'Components/EmptyState/EmptyState';
import Button from 'Components/Button';
import CropIcon from 'Components/icons/CropIcon';
import CloseIcon from 'Components/icons/CloseIcon';
import BlackAndWhiteIcon from 'Components/icons/BlackAndWhiteIcon';
import ImageDeleteIcon from 'Components/icons/ImageDeleteIcon';
import ImageDuplicateIcon from 'Components/icons/ImageDuplicateIcon';
import ImageRedactIcon from 'Components/icons/ImageRedactIcon';
import ImageRotateIcon from 'Components/icons/ImageRotateIcon';
import ImageSharpenIcon from 'Components/icons/ImageSharpenIcon';
import PencilIcon from 'Components/icons/PencilIcon';
import InformationBubble from 'Components/information-bubble/InformationBubble';
import SelectInput from 'Components/forms/select-input/SelectInput.jsx';
import ZoomOutIcon from 'Components/icons/ZoomOutIcon';
import ZoomInIcon from 'Components/icons/ZoomInIcon';
import PagesIcon from 'Components/icons/PagesIcon';
import PageSelector from 'Components/PageSelector';
import { filterImage } from 'Utils/imageUtil.js';
import { connect } from 'react-redux';
import { transformImage } from 'Actions/imageEditorAction';
import ChangingProgressProvider from "Components/ChangingProgressProvider/ChangingProgressProvider.js";
import { CircularProgressbar, buildStyles } from 'react-circular-progressbar';
import 'react-circular-progressbar/dist/styles.css';
import './ImageToolkitModal.scss';
import 'cropperjs/dist/cropper.css';
import OpenNewWindowIcon from 'Components/icons/OpenNewWindowIcon/OpenNewWindowIcon.jsx';
import DownloadIcon from 'Components/icons/download-icon/DownloadIcon.jsx';
import LeftArrowIcon from '../icons/left-arrow-icon/LeftArrowIcon';
import RightArrowIcon from '../icons/right-arrow-icon/RightArrowIcon';
import counterpart from 'counterpart';
import * as KeyConstants from 'Utils/constants/keyConstants.js';
const __UNDER_SCORE__ = "_";
const __ON_KEY_DOWN__ = 'keydown';
const __ON_KEY_PRESS__ = 'keypress';
import { COLORS } from "Constants/BIDashboardConstants"
/*
const GROUP_BUTTONS = [
  {
    'title': 'Crop',
    'action': this.rotateToRight.bind(this),
    'icon': ImageDuplicateIcon,
  }
]
*/

export class ImageToolkitModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      rotateImage: [
        {
          rotateIndex: 0,
        },
      ],
      operationPerformed: [
        {
          flag: false,
        },
      ],
      canvasSelectedIndex: 0,
      pencilColor: '#0F7DC4',
      selectedZoom: { value: 100, text: '100%' },
      currentZoomValue: 0.0,
      zoomText: '100%',
      zoomValues: [
        {
          value: -0.5,
          text: '50%',
        },
        {
          value: -0.4,
          text: '60%',
        },
        {
          value: -0.3,
          text: '70%',
        },
        {
          value: -0.2,
          text: '80%',
        },
        {
          value: -0.1,
          text: '90%',
        },
        {
          value: 0.0,
          text: '100%',
        },
        {
          value: 0.1,
          text: '110%',
        },
        {
          value: 0.2,
          text: '120%',
        },
        {
          value: 0.3,
          text: '130%',
        },
        {
          value: 0.4,
          text: '140%',
        },
        {
          value: 0.5,
          text: '150%',
        },
        {
          value: 0.6,
          text: '160%',
        },
        {
          value: 0.7,
          text: '170%',
        },
        {
          value: 0.8,
          text: '180%',
        },
        {
          value: 0.9,
          text: '190%',
        },
        {
          value: 1.0,
          text: '200%',
        },

      ],
      pageList: [],
      imageZoom: 0.1,
      dragMode: 'move',
      showPageSelector: false,
      toggleRedact: false,
      toggleCrop: false,
      showImageToolkit: false,
      refLoaded: false,
    };

    this.updatePageSelectionIndex = this.updatePageSelectionIndex.bind(this);
    this.toggleCanvas = this.toggleCanvas.bind(this);
    this.addCropFloatingButton = this.addCropFloatingButton.bind(this);
    this.onKeyPress = this.onKeyPress.bind(this);
  }

  componentWillMount() {
    let pageListClone = [];
    let rotateImageClone = [];
    let operationPerformedClone = [];
    this.props.imageContents.map((image, imageIndex) => {
      rotateImageClone = rotateImageClone.concat({ rotateIndex: 0 });
      operationPerformedClone = operationPerformedClone.concat({ flag: false });
      pageListClone = pageListClone.concat({ pageId: imageIndex, pageContent: image });
    });
    const pageListBackup = JSON.parse(JSON.stringify(pageListClone));
    this.setState({
      pageList: pageListClone,
      rotateImage: rotateImageClone,
      operationPerformed: operationPerformedClone,
      orignalImages: pageListBackup,
    });
    document.addEventListener(__ON_KEY_DOWN__, this.onKeyPress);
    document.addEventListener(__ON_KEY_PRESS__, this.onKeyPress);
  }
  componentWillUnmount() {
    document.removeEventListener(__ON_KEY_DOWN__, this.onKeyPress);
    document.removeEventListener(__ON_KEY_PRESS__, this.onKeyPress);
  }
  componentDidMount() {
    const { canvas } = this.refs;
    const ctx = canvas.getContext('2d');
    let image = new Image()
    const img = this.refs.image;

    image.onload = () => {
      draw(this);
    };

    function draw(img) {
      ctx.drawImage(img, 0, 0, img.width / 4, img.height / 4);
    }
    this.forceUpdate();
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.imageContents.length !== this.props.imageContents.length) {
      let pageListClone = [];
      let rotateImageClone = [];
      let operationPerformedClone = [];

      nextProps.imageContents.forEach((image, imageIndex) => {
        rotateImageClone = rotateImageClone.concat({ rotateIndex: 0 });
        operationPerformedClone = operationPerformedClone.concat({ flag: false });
        pageListClone = pageListClone.concat({ pageId: imageIndex, pageContent: image });
      });

      const pageListBackup = JSON.parse(JSON.stringify(pageListClone));
      this.setState({
        imageZoom: 0.3,
        pageList: pageListClone,
        rotateImage: rotateImageClone,
        operationPerformed: operationPerformedClone,
        orignalImages: pageListBackup,
      });
    }
    if (this.props.updateFlag !== nextProps.updateFlag) {
      this.toggleCanvas(this.state.pageList);
    }
  }

  _crop(event) {
    this.setState({
      cropped: this.refs.cropper.getCroppedCanvas().toDataURL(),
    });
  }
  onKeyPress(event) {
    const eventCode = event.code ? (event.code) : event.key;
    switch (eventCode) {
      case KeyConstants.RIGHTARROW:
      case KeyConstants.KEY_CODE_RIGHTARROW:
        this.props.updatePageSelectionIndex == undefined ? this.updatePageSelectionIndex(this.state.canvasSelectedIndex + 1) : this.props.updatePageSelectionIndex(this.props.canvasSelectedIndex + 1)
        event.preventDefault();
        //Go to next page
        break;
      case KeyConstants.LEFTARROW:
      case KeyConstants.KEY_CODE_LEFTARROW:
        this.props.updatePageSelectionIndex == undefined ? this.updatePageSelectionIndex(this.state.canvasSelectedIndex - 1) : this.props.updatePageSelectionIndex(this.props.canvasSelectedIndex - 1)
        event.preventDefault();
        //Go to prev page
        break;

    }

  }
  imageTrasformation(imageOperation) {
    if (this.refs.cropper !== undefined) {
      const imageWidth = this.refs.cropper.getImageData().naturalWidth;
      const imageHeight = this.refs.cropper.getImageData().naturalHeight;
      const img = new Image();
      img.src = this.state.pageList[this.props.canvasSelectedIndex == undefined ? this.state.canvasSelectedIndex : this.props.canvasSelectedIndex].pageContent;
      const data = filterImage(img, imageWidth, imageHeight, imageOperation);

      if (data) {
        const pageListClone = [...this.state.pageList];
        const operationPerformedClone = [...this.state.operationPerformed];
        pageListClone[this.props.canvasSelectedIndex === undefined ? this.state.canvasSelectedIndex : this.props.canvasSelectedIndex].pageContent = data;
        operationPerformedClone[this.props.canvasSelectedIndex === undefined ? this.state.canvasSelectedIndex : this.props.canvasSelectedIndex].flag = true;
        if (this.props.updatePageList !== undefined) { this.props.updatePageList(pageListClone); }
        this.setState({
          pageList: pageListClone,
          operationPerformed: operationPerformedClone,
        });
      }
    }
  }

  sharpenTheImage() {
    this.imageTrasformation('sharpen');
  }

  handlePageSelector() {
    const pageSelector = !this.state.showPageSelector;
    this.setState(prevState => ({
      showPageSelector: pageSelector,
      showImageToolkit: pageSelector ? false : prevState.showImageToolkit,
    }));
  }

  showImageToolKit = () => {
    const showImageToolkit = !this.state.showImageToolkit;
    this.setState(prevState => ({
      ...prevState,
      showImageToolkit,
      showPageSelector: showImageToolkit ? false : prevState.showPageSelector,
      pencilColor: showImageToolkit ? '#9A9FAC' : '#0F7DC4',
    }));
  }

  duplicateImage() {
    const nextPageSize = this.state.pageList.length;
    const pageListClone = this.state.pageList.concat({
      pageContent: this.state.pageList[this.props.canvasSelectedIndex === undefined ? this.state.canvasSelectedIndex : this.props.canvasSelectedIndex].pageContent,
      pageId: nextPageSize,
    });
    if (this.props.updatePageList !== undefined) { this.props.updatePageList(pageListClone); }
    this.setState(prevState => ({
      ...prevState,
      pageList: pageListClone,
      operationPerformed: prevState.operationPerformed.concat({ flag: 0 }),
      rotateImage: prevState.rotateImage.concat({ rotateIndex: 0 }),
    }));
  }


  deleteImage() {
    const tempPageList = this.state.pageList.filter((image) => {
      return image.pageId !== (this.props.canvasSelectedIndex == undefined ? this.state.canvasSelectedIndex : this.props.canvasSelectedIndex);
    });
    if (this.props.updatePageList !== undefined) { this.props.updatePageList(tempPageList, 0); }
    this.setState({
      pageList: tempPageList,
      canvasSelectedIndex: 0,
    });
  }

  makeGrayScale() {
    this.imageTrasformation('grayscale');
  }

  getMaskedCanvas(sourceImage, cropper) {
    const canvas = document.createElement('canvas');
    const context = canvas.getContext('2d');

    const maskWidth = cropper.getData().width;
    const maskHeight = cropper.getData().height;
    const maskTop = cropper.getData().y;
    const maskLeft = cropper.getData().x;

    const imageWidth = cropper.getImageData().naturalWidth;
    const imageHeight = cropper.getImageData().naturalHeight;

    canvas.width = imageWidth;
    canvas.height = imageHeight;
    context.imageSmoothingEnabled = true;

    const image = new Image();
    image.src = sourceImage;

    context.drawImage(image, 0, 0, imageWidth, imageHeight);
    context.fillRect(maskLeft, maskTop, maskWidth, maskHeight);
    return canvas;
  }

  getFakeCanvas(sourceImage, cropper) {
    const canvas = document.createElement('canvas');
    const context = canvas.getContext('2d');
    const imageWidth = cropper.getImageData().naturalWidth;
    const imageHeight = cropper.getImageData().naturalHeight;

    canvas.width = imageWidth - 1;
    canvas.height = imageHeight - 1;
    context.imageSmoothingEnabled = true;

    const image = new Image();
    image.src = sourceImage;
    context.drawImage(image, 0, 0, imageWidth, imageHeight);

    return canvas;
  }

  addCropFloatingButton(child, addbutton) {
    addbutton.className = 'crop-floating-button';
    addbutton.id = 'crop';
    addbutton.innerText = 'Crop';
    child.parentNode.insertBefore(addbutton, child.nextSibling);
    addbutton.onclick = this.buttonCrop.bind(this);
  }

  startCrop() {
    const node = ReactDOM.findDOMNode(this);

    if (node instanceof HTMLElement && !node.querySelector('.crop-floating-button')) {
      const child = node.querySelector('.point-se');
      const addbutton = document.createElement('button');
      this.addCropFloatingButton(child, addbutton);
    }

    if (!this.state.toggleRedact) {
      if (this.state.toggleCrop) {
        const pageListClone = [...this.state.pageList];
        pageListClone[this.state.canvasSelectedIndex].pageContent = this.state.cropped;

        const operationPerformedClone = [...this.state.operationPerformed];
        operationPerformedClone[this.state.canvasSelectedIndex].flag = true;
        if (this.props.updatePageList !== undefined) { this.props.updatePageList(pageListClone); }
        this.setState(prevState => ({
          ...prevState,
          pageList: pageListClone,
          operationPerformed: operationPerformedClone,
          dragMode: 'move',
          toggleCrop: !prevState.toggleCrop,
        }));
      } else {
        this.setState(prevState => ({
          ...prevState,
          dragMode: 'crop',
          toggleCrop: !prevState.toggleCrop,
        }));
      }
    }
  }

  buttonCrop() {
    if (!this.state.toggleRedact) {
      if (this.state.toggleCrop) {
        const pageListClone = [...this.state.pageList];
        pageListClone[this.props.canvasSelectedIndex === undefined ? this.state.canvasSelectedIndex : this.props.canvasSelectedIndex].pageContent = this.state.cropped;

        const operationPerformedClone = [...this.state.operationPerformed];
        operationPerformedClone[this.props.canvasSelectedIndex === undefined ? this.state.canvasSelectedIndex : this.props.canvasSelectedIndex].flag = true;
        if (this.props.updatePageList !== undefined) { this.props.updatePageList(pageListClone); }
        this.setState(prevState => ({
          ...prevState,
          pageList: pageListClone,
          operationPerformed: operationPerformedClone,
          dragMode: 'move',
          toggleCrop: !prevState.toggleCrop,
        }));
      } else {
        this.setState(prevState => ({
          ...prevState,
          dragMode: 'crop',
          toggleCrop: !prevState.toggleCrop,
        }));
      }
    }
  }

  toggleCanvas(pageList) {
    const currentImage = pageList[this.props.canvasSelectedIndex === undefined ? this.state.canvasSelectedIndex : this.props.canvasSelectedIndex].pageContent;
    const maskedCanvas = this.getFakeCanvas(currentImage, this.refs.cropper);
    const pageListClone = [...pageList];
    pageListClone[this.props.canvasSelectedIndex === undefined ? this.state.canvasSelectedIndex : this.props.canvasSelectedIndex].pageContent = maskedCanvas.toDataURL();

    if (this.props.updatePageList !== undefined) { this.props.updatePageList(pageListClone); }
    this.setState({
      pageList: pageListClone,
      dragMode: 'move',
    });
  }

  maskTheImage() {
    if (!this.state.toggleCrop) {
      if (this.state.toggleRedact) {
        const currentImage = this.state.pageList[this.props.canvasSelectedIndex === undefined ? this.state.canvasSelectedIndex : this.props.canvasSelectedIndex].pageContent;
        const maskedCanvas = this.getMaskedCanvas(currentImage, this.refs.cropper);
        const pageListClone = this.state.pageList;
        pageListClone[this.props.canvasSelectedIndex === undefined ? this.state.canvasSelectedIndex : this.props.canvasSelectedIndex].pageContent = maskedCanvas.toDataURL();

        const operationPerformedClone = [...this.state.operationPerformed];
        operationPerformedClone[this.props.canvasSelectedIndex === undefined ? this.state.canvasSelectedIndex : this.props.canvasSelectedIndex].flag = true;
        if (this.props.updatePageList !== undefined) { this.props.updatePageList(pageListClone); }
        this.setState(prevState => ({
          ...prevState,
          dragMode: 'move',
          pageList: pageListClone,
          operationPerformed: operationPerformedClone,
          toggleRedact: !prevState.toggleRedact,
          toggleCrop: false,
        }));
      } else {
        // Display crop region on the canvas.
        this.setState(prevState => ({
          ...prevState,
          dragMode: 'crop',
          toggleRedact: !prevState.toggleRedact,
          toggleCrop: false,
        }));
      }
    }
  }

  undoEditing = () => {
    const pageListClone = [...this.state.pageList];
    const operationPerformedClone = [...this.state.operationPerformed];
    pageListClone[this.props.canvasSelectedIndex === undefined ? this.state.canvasSelectedIndex : this.props.canvasSelectedIndex].pageContent = this.state.orignalImages[this.props.canvasSelectedIndex === undefined ? this.state.canvasSelectedIndex : this.props.canvasSelectedIndex].pageContent;
    operationPerformedClone[this.props.canvasSelectedIndex === undefined ? this.state.canvasSelectedIndex : this.props.canvasSelectedIndex].flag = false;


    const rotateImageClone = [...this.state.rotateImage];
    rotateImageClone[this.props.canvasSelectedIndex === undefined ? this.state.canvasSelectedIndex : this.props.canvasSelectedIndex].rotateIndex = 0;
    if (this.props.updatePageList !== undefined) { this.props.updatePageList(pageListClone); }

    this.setState({
      pageList: pageListClone,
      dragMode: 'move',
      toggleCrop: false,
      toggleRedact: false,
      rotateImage: rotateImageClone,
      operationPerformed: operationPerformedClone,
      imageZoom: 0.3,
    });
  }

  filterOnChange(details) {
  }

  rotateToRight = () => {
    this.refs.cropper.rotate(90);
    const pageListClone = [...this.state.pageList];
    const rotatedImage = this.refs.cropper.getCroppedCanvas().toDataURL();
    pageListClone[this.props.canvasSelectedIndex === undefined ? this.state.canvasSelectedIndex : this.props.canvasSelectedIndex].pageContent = rotatedImage;
    const operationPerformedClone = [...this.state.operationPerformed];
    operationPerformedClone[this.props.canvasSelectedIndex === undefined ? this.state.canvasSelectedIndex : this.props.canvasSelectedIndex].flag = true;
    if (this.props.updatePageList !== undefined) { this.props.updatePageList(pageListClone); }
    this.setState({
      pageList: pageListClone,
      operationPerformed: operationPerformedClone,
      zoomText: '100%',
      currentZoomValue: 0.0,
    });
  }

  zoomIn = () => {
    if (this.state.currentZoomValue < 1) {
      this.refs.cropper.zoom(0.1);
      this.setState(prevState => ({
        currentZoomValue: parseFloat((prevState.currentZoomValue + 0.1).toFixed(1)),
      }),
        this.setZoomValue);
    }
  }

  zoomOut = () => {
    if (this.state.currentZoomValue > -0.5) {
      this.refs.cropper.zoom(-0.1);
      this.setState(prevState => ({
        ...prevState,
        currentZoomValue: parseFloat((prevState.currentZoomValue - 0.1).toFixed(1)),
      }),
        this.setZoomValue);
    }
  }

  setZoomValue() {
    this.state.zoomValues.map((item) => {
      if (this.state.currentZoomValue === item.value) {
        this.setState({
          zoomText: item.text,
        });
      }
    });
  }

  cropstart(event) {
  }

  getCroppedCanvas(options) {
  }


  updatePageSelectionIndex(canvasSelectedIndex) {
    if (canvasSelectedIndex >= 0 && this.state.pageList.length > canvasSelectedIndex) {
      this.refs.cropper.zoom(0.0);
      this.setState({
        canvasSelectedIndex,
        currentZoomValue: 0.0,
        zoomText: '100%',
      });
    }
  }

  checkDistance(x, y) {
    let prev;
    let dist = 9999;
    let i;
    const array = this.state.zoomValues;
    for (i = 0; i < array.length; i++) {
      if (array[i].value === x || array[i].value === y) {
        prev = i;
        break;
      }
    }
    for (i = prev + 1; i < array.length; i++) {
      if (array[i].value === x || array[i].value === y) {
        if (array[i].value != array[prev].value && (i - prev) < dist) {
          dist = i - prev;
          prev = i;
        } else {
          prev = i;
        }
      }
    }
    if (dist === 9999) { return 0; }
    if (x < 0 && x < y) { return -dist; }
    return dist;
  }

  onZoom = (option) => {
    const zoomOption = this.state.zoomValues.find((item) => item.value === option);
    let currentZoom = parseInt(this.state.currentZoomValue*10);
    let zoomVal = parseInt(zoomOption.value*10);
    while (zoomVal != currentZoom) {
      if (zoomVal > currentZoom) {
        this.refs.cropper.zoom(0.1);
        zoomVal--;
      } else if (zoomVal < currentZoom) {
        this.refs.cropper.zoom(-0.1);
        zoomVal++;
      }
    } 
    
    if (zoomOption) {
      this.setState({
        selectedZoom: zoomOption,
        currentZoomValue:zoomOption.value,
        zoomText: zoomOption.text,
      });
    }
  }

  renderHeader = () => {
    return (
      <div className="modal-header">
        <div className="header-left">
          <div className="attached">Attached Document</div>
          <div className="header-title">{this.props.currentTitle}</div>
        </div>
        <div className="button-container">
          {
            !this.props.imageContentsErr && (
              <div className="open-document">
                <OpenNewWindowIcon
                  onClick={this.props.openDocument}
                  height={20}
                  width={20}
                />
              </div>
            )}
          {!this.props.downloadInProgress && this.props.user.parsedPermissions.document && this.props.user.parsedPermissions.document.download
            && <div className="open-document">
              <DownloadIcon
                onClick={this.props.downloadDocument}
                height={20}
                width={20}
              />
            </div>}
          {
            this.props.downloadInProgress &&
            <div className="document-loading">

              <ChangingProgressProvider
                values={[12, 20, 48, 52, 57, 63, 69, 72, 77, 83, 88, 93, 100]}
                pauseValue={93}
              >
                {percentage => (
                  <CircularProgressbar value={percentage} text={`${percentage}%`}
                    styles={buildStyles({
                      pathColor: COLORS.oneGp.globalBlue,
                      textColor: COLORS.oneGp.globalBlue,
                      textSize: "25px"
                    })} />
                )}
              </ChangingProgressProvider>
            </div>
          }

          <Button
            action={this.props.closeModal}
            category="primary toggled"
            icon={CloseIcon}
            iconDirection="right"
          />
        </div>
      </div>
    );
  }
  renderCropper = () => {
    const canvasSelectedIndex = this.props.canvasSelectedIndex == undefined ? this.state.canvasSelectedIndex : (this.props.canvasSelectedIndex !== undefined && this.state.pageList.length - 1 < this.props.canvasSelectedIndex) ? 0 : this.props.canvasSelectedIndex;
    // This flag is used for disable delete button if image is already attached
    return this.refs.image === undefined ? (<div />) : (
      <Cropper
        style={{
          width: '100%',
          height: '88vh',
        }}
        ref="cropper"
        src={this.state.pageList[canvasSelectedIndex].pageContent}
        guides={false}
        highlight
        rotatable
        autoCrop={false}
        dragMode={this.state.dragMode}
        center
        responsive
        cropBoxMovable
        cropBoxResizable
        crop={this._crop.bind(this)}
        rotateTo={this.state.rotateImage[canvasSelectedIndex].rotateIndex}
        zoomOnWheel={false}
        toggleDragModeOnDblclick={false}
        getCroppedCanvas={this.getCroppedCanvas.bind(this)}
        cropstart={this.cropstart.bind(this)}
      />
    );
  }

  render() {
    const canvasSelectedIndex = this.props.canvasSelectedIndex == undefined ? this.state.canvasSelectedIndex : (this.props.canvasSelectedIndex !== undefined && this.state.pageList.length - 1 < this.props.canvasSelectedIndex) ? 0 : this.props.canvasSelectedIndex;
    const isAttachedSelected = this.props.selectedPages !== undefined ? (this.props.selectedPages.findIndex((image) => {
      return image.isSelected && image.pageId == (this.props.canvasSelectedIndex === undefined ? this.state.canvasSelectedIndex : this.props.canvasSelectedIndex);
    })) : -1;

    const currentIndex = canvasSelectedIndex;
    const totalPages = this.state.pageList.length;

    const isLeftDisabled = currentIndex <= 0;
    const isRightDisabled = currentIndex >= totalPages - 1;

    return (
      <>
        {!this.props.imageContentsErr && (
          <div className="editor timeline">
            {this.renderHeader()}
            {this.renderCropper()}
            {this.state.showImageToolkit && (
              <div className={this.props.isModal ? "image-float-toolkit" : "image-float-toolkitnomodal"}>
                <ul className="image-ops">

                  <li className="tool-item">
                    <InformationBubble
                      id="1"
                      tooltipContent="Crop"
                    >
                      <div>
                        <Button
                          action={this.startCrop.bind(this)}
                          category="image-tool toggled"
                          icon={CropIcon}
                          iconDirection="left"
                        />
                      </div>
                    </InformationBubble>
                  </li>
                  <li className="tool-item">
                    <InformationBubble
                      id="2"
                      tooltipContent="Rotate"
                    >
                      <div>
                        <Button
                          action={this.rotateToRight}
                          category="image-tool toggled"
                          icon={ImageRotateIcon}
                          iconDirection="left"
                        />
                      </div>

                    </InformationBubble>
                  </li>
                  <li className="tool-item">
                    <InformationBubble
                      id="3"
                      tooltipContent="Sharpen"
                    >
                      <Button
                        action={this.sharpenTheImage.bind(this)}
                        category="image-tool toggled"
                        icon={ImageSharpenIcon}
                        iconDirection="left"
                      />
                    </InformationBubble>
                  </li>
                  <li className="tool-item">
                    <InformationBubble
                      id="4"
                      tooltipContent="Convert Grayscale"
                    >
                      <Button
                        action={this.makeGrayScale.bind(this)}
                        category="image-tool toggled"
                        icon={BlackAndWhiteIcon}
                        iconDirection="left"
                      />
                    </InformationBubble>
                  </li>
                  <li className="tool-item">
                    <InformationBubble
                      id="5"
                      tooltipContent="Redact"
                    >
                      <Button
                        action={this.maskTheImage.bind(this)}
                        category="image-tool toggled"
                        icon={ImageRedactIcon}
                        iconDirection="left"
                      />
                    </InformationBubble>
                  </li>

                  <li className="tool-item">
                    <InformationBubble
                      id="6"
                      tooltipContent="Duplicate"
                    >
                      <Button
                        action={this.duplicateImage.bind(this)}
                        category="image-tool toggled"
                        icon={ImageDuplicateIcon}
                        iconDirection="left"
                      />
                    </InformationBubble>
                  </li>

                  <li className="tool-item">
                    <InformationBubble
                      id="7"
                      tooltipContent="Delete"
                    >
                      <Button
                        action={this.deleteImage.bind(this)}
                        category="image-tool toggled"
                        icon={ImageDeleteIcon}
                        iconDirection="left"
                        disabled={isAttachedSelected !== -1}
                      />
                    </InformationBubble>
                  </li>
                </ul>
              </div>
            )
            }
            {this.state.pageList.length > 0 && (
              <div className="image-float-toolkit modal-kit">
                <div>
                  <div className="modal-kit">
                    <ul className="main-list">
                      <li style={{paddingRight:'unset'}}>
                        <Button
                          extraClass="pages-button"
                          action={this.handlePageSelector.bind(this)}
                          category="image-tool-pages"
                          iconDirection="left"
                        >
                          <PagesIcon />
                          <div className="pages-button-text-wrapper">
                            <span className="pages-button-text-wrapper-lable">Page</span>
                            <span className="pages-button-text-wrapper-number">{canvasSelectedIndex + 1}</span>
                            <span className="pages-button-text-wrapper-lable">of</span>
                            <span className="pages-button-text-wrapper-number">{this.state.pageList.length}</span>
                          </div>
                        </Button>
                      </li>
                      <li
                          className={`page-nav ${isLeftDisabled ? 'arrow-disabled' : ''}`}
                          onClick={
                            isLeftDisabled
                              ? undefined
                              : this.props.updatePageSelectionIndex == undefined
                                ? () => this.updatePageSelectionIndex(currentIndex - 1)
                                : () => this.props.updatePageSelectionIndex(currentIndex - 1)
                          }
                        >
                          <LeftArrowIcon disabled={isLeftDisabled} />
                        </li>
                        <li
                          className={`page-nav ${isRightDisabled ? 'arrow-disabled' : ''}`}
                          onClick={
                            isRightDisabled
                              ? undefined
                              : this.props.updatePageSelectionIndex == undefined
                                ? () => this.updatePageSelectionIndex(currentIndex + 1)
                                : () => this.props.updatePageSelectionIndex(currentIndex + 1)
                          }
                        >
                          <RightArrowIcon disabled={isRightDisabled} />
                        </li>
                      {
                        this.props.isRotate && (
                          <li>
                          <Button
                          action={this.rotateToRight}
                          category="image-tool toggled"
                          icon={ImageRotateIcon}
                          iconDirection="left"
                        />
                        </li>
                        )
                      }
                      {
                        this.props.idEditable && (
                          <li>
                            <Button
                              action={this.showImageToolKit}
                              category="image-tool toggled"
                              icon={() => PencilIcon(this.state.pencilColor)}
                              iconDirection="left"
                            />
                          </li>
                        )}
                      {Boolean(this.state.operationPerformed[canvasSelectedIndex].flag) && !this.props.isRotate &&(
                        <li>
                          <Button
                            action={this.undoEditing}
                            extraClass="pages-button"
                            category="image-tool-undo"
                          >
                            <div className="pages-button-text-wrapper">
                              <span className="pages-button-undo-lable">Undo Editing</span>
                            </div>
                          </Button>
                        </li>
                      )
                      }
                    </ul>
                    <ul className="zoom-options">
                      <li>
                        <Button
                          action={this.zoomIn}
                          category="image-tool toggled"
                          icon={ZoomInIcon}
                          iconDirection="left"
                        />
                      </li>

                      <li>
                        <Button
                          action={this.zoomOut}
                          category="image-tool toggled"
                          icon={ZoomOutIcon}
                          iconDirection="left"
                        />
                      </li>
                      <li>
                        <SelectInput
                          dataList={this.state.zoomValues}
                          promptText={`Zoom: ${this.state.zoomText}`}
                          handleSelection={this.onZoom}
                          wrapperClass="select-menu__form reports image-modal"
                          extraClass="option-box"
                          selectClass={{
                            color: '#007dc3',
                          }}
                        />
                      </li>
                    </ul>
                  </div>
                </div>
                {this.state.showPageSelector && (
                  <div className="page-selector modal-toolkit">
                    <PageSelector
                      id={this.props.id}
                      pageList={this.state.pageList}
                      updatePageSelectionIndex={this.props.updatePageSelectionIndex === undefined ? this.updatePageSelectionIndex : this.props.updatePageSelectionIndex}
                      canvasSelectedIndex={canvasSelectedIndex}
                      updateParentSelectedPages={this.props.updateParentSelectedPages}
                      imageCheckBoxRequired={this.props.imageCheckBoxRequired}
                      selectedPages={this.props.selectedPages}
                      selectAllFlag={this.props.selectAllFlag}
                      unlinkSelectedImages={this.props.unlinkSelectedImages}
                    />
                  </div>
                )
                }
              </div>
            )}
          </div>
        )
        }
        {
          this.props.imageContents.length === 0 && !this.props.imageContentsErr && <BVLoader20 />
        }
        {
          this.props.imageContentsErr && (
            <div className="editor timeline">
              {this.renderHeader()}
              <div style={{
                marginTop: '50px',
                backgroundColor: 'whitesmoke',
              }}>
                <EmptyState
                  translations={{ emptyStateHeading: counterpart('globalTranslate.queues.emptyStateHeading'), emptyStateDescription: counterpart('globalTranslate.queues.emptyStateDescription') }}
                />
              </div>
            </div>
          )
        }

        <div className="hiddenCanvas " style={{ width: '100%', height: '100%' }}>
          <img ref="image" alt="canvas selection" src={this.state.pageList.length > 0 && this.state.pageList[canvasSelectedIndex].pageContent} />
          <canvas ref="canvas" />
        </div>
      </>
    );
  }
}

ImageToolkitModal.defaultProps = {
  title: 'Attach Document to Case',
  imageContents: [],
  imageContentsErr: false,
  addClass: false,
  transformedImageData: {},
  unlinkSelectedImages: () => { },
  updatePageList: () => { },
  updateParentSelectedPages: () => { },
  updateFlag: false,
  zoomStyle: {},
  idEditable: false,
};

ImageToolkitModal.propTypes = {
  title: PropTypes.string,
  unlinkSelectedImages: PropTypes.func,
  updatePageList: PropTypes.func,
  updateParentSelectedPages: PropTypes.func,
  transformedImageData: PropTypes.object,
  imageContents: PropTypes.array,
  imageContentsErr: PropTypes.bool,
  updateFlag: PropTypes.bool,
  addClass: PropTypes.bool,
  zoomStyle: PropTypes.object,
  idEditable: PropTypes.bool,
  isRotate: PropTypes.bool,
  downloadInProgress: PropTypes.bool,
  downloadDocument: PropTypes.func,
  user: PropTypes.object,
};


function mapStateToProps(state) {
  return {
    transformedImageData: state.imageEditorData,
    user: state.auth.user,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    transformImage: (image, imageIndex, imageWidth, imageHeight, imageOperation) => dispatch(transformImage(image, imageIndex, imageWidth, imageHeight, imageOperation)),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(ImageToolkitModal);